import BaseButton from '@material-ui/core/Button'

const Button = BaseButton

export default Button
